import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | null;
const termsContent = <div className="space-y-4 text-brand-brownLight text-sm leading-relaxed" data-id="element-96">
    <h3 className="text-lg font-bold text-brand-brown" data-id="element-97">
      1. Aceptación de los Términos
    </h3>
    <p data-id="element-98">
      Al acceder y utilizar este sitio web y adquirir nuestros productos
      digitales, usted acepta cumplir con estos Términos y Condiciones. Si no
      está de acuerdo con alguno de estos términos, le recomendamos no utilizar
      nuestros servicios.
    </p>

    <h3 className="text-lg font-bold text-brand-brown" data-id="element-99">
      2. Productos Digitales
    </h3>
    <p data-id="element-100">
      Los ebooks y materiales digitales ofrecidos en este sitio son productos
      descargables. Una vez completada la compra, recibirá acceso inmediato a
      los archivos digitales a través del correo electrónico proporcionado.
    </p>

    <h3 className="text-lg font-bold text-brand-brown" data-id="element-101">
      3. Política de Reembolso
    </h3>
    <p data-id="element-102">
      Ofrecemos una garantía de satisfacción de 30 días. Si no está satisfecho
      con su compra, puede solicitar un reembolso completo dentro de los 30 días
      posteriores a la fecha de compra enviando un correo electrónico a nuestro
      equipo de soporte.
    </p>

    <h3 className="text-lg font-bold text-brand-brown" data-id="element-103">
      4. Propiedad Intelectual
    </h3>
    <p data-id="element-104">
      Todo el contenido de los ebooks, incluyendo textos, imágenes, recetas y
      diseños, está protegido por derechos de autor. Queda prohibida la
      reproducción, distribución o reventa total o parcial de los materiales sin
      autorización expresa.
    </p>

    <h3 className="text-lg font-bold text-brand-brown" data-id="element-105">5. Uso Personal</h3>
    <p data-id="element-106">
      Los productos adquiridos son para uso personal y no comercial. No está
      permitido compartir, redistribuir o revender los materiales digitales.
    </p>

    <h3 className="text-lg font-bold text-brand-brown" data-id="element-107">
      6. Limitación de Responsabilidad
    </h3>
    <p data-id="element-108">
      Las recetas e información proporcionada son de carácter educativo. No nos
      hacemos responsables por reacciones alérgicas o intolerancias
      individuales. Consulte siempre con su médico o nutricionista ante
      cualquier duda sobre su dieta.
    </p>
  </div>;
const privacyContent = <div className="space-y-4 text-brand-brownLight text-sm leading-relaxed" data-id="element-109">
    <h3 className="text-lg font-bold text-brand-brown" data-id="element-110">
      1. Información que Recopilamos
    </h3>
    <p data-id="element-111">
      Recopilamos información personal que usted nos proporciona voluntariamente
      al realizar una compra, como su nombre, dirección de correo electrónico y
      datos de pago. No almacenamos datos de tarjetas de crédito directamente.
    </p>

    <h3 className="text-lg font-bold text-brand-brown" data-id="element-112">
      2. Uso de la Información
    </h3>
    <p data-id="element-113">
      Utilizamos su información personal para: procesar sus pedidos, enviar los
      productos digitales adquiridos, comunicarnos sobre su compra y enviar
      información relevante sobre nuestros productos (solo si ha dado su
      consentimiento).
    </p>

    <h3 className="text-lg font-bold text-brand-brown" data-id="element-114">
      3. Protección de Datos
    </h3>
    <p data-id="element-115">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      su información personal contra acceso no autorizado, alteración,
      divulgación o destrucción.
    </p>

    <h3 className="text-lg font-bold text-brand-brown" data-id="element-116">4. Cookies</h3>
    <p data-id="element-117">
      Nuestro sitio web utiliza cookies para mejorar su experiencia de
      navegación y analizar el tráfico del sitio. Puede configurar su navegador
      para rechazar cookies, aunque esto podría afectar la funcionalidad del
      sitio.
    </p>

    <h3 className="text-lg font-bold text-brand-brown" data-id="element-118">5. Terceros</h3>
    <p data-id="element-119">
      No vendemos, intercambiamos ni transferimos su información personal a
      terceros, excepto a proveedores de servicios de confianza que nos asisten
      en la operación del sitio web y el procesamiento de pagos.
    </p>

    <h3 className="text-lg font-bold text-brand-brown" data-id="element-120">6. Sus Derechos</h3>
    <p data-id="element-121">
      Usted tiene derecho a acceder, rectificar o eliminar sus datos personales
      en cualquier momento. Para ejercer estos derechos, contáctenos a través de
      nuestro correo electrónico de soporte.
    </p>

    <h3 className="text-lg font-bold text-brand-brown" data-id="element-122">
      7. Cambios en la Política
    </h3>
    <p data-id="element-123">
      Nos reservamos el derecho de actualizar esta política de privacidad en
      cualquier momento. Los cambios serán publicados en esta página con la
      fecha de última actualización.
    </p>
  </div>;
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brand-brown text-brand-cream py-12 px-4" data-id="element-124">
        <div className="max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-125">
          <div className="mb-8" data-id="element-126">
            <h2 className="font-heading text-2xl font-bold italic mb-2" data-id="element-127">
              COCINANDO SIN GLUTEN
            </h2>
            <p className="text-brand-cream/60 text-sm max-w-md mx-auto" data-id="element-128">
              Transformando la panadería y repostería en casa para una vida más
              saludable, sin sacrificar el sabor.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-cream/80 mb-8" data-id="element-129">
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors cursor-pointer" data-id="element-130">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors cursor-pointer" data-id="element-131">
              Política de Privacidad
            </button>
          </div>

          <p className="text-xs text-brand-cream/40" data-id="element-132">
            © 2026 Cocinando Sin Gluten. Todos los derechos reservados. Este
            sitio no es parte del sitio web de Facebook o Facebook Inc.
          </p>
        </div>
      </footer>

      {/* Legal Modals */}
      <AnimatePresence data-id="element-133">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-134">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-135">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0" data-id="element-136">
                <h2 className="text-xl font-heading font-bold text-brand-brown" data-id="element-137">
                  {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-gray-100 transition-colors text-brand-brownLight hover:text-brand-brown" aria-label="Cerrar" data-id="element-138">
                  <XIcon className="w-5 h-5" data-id="element-139" />
                </button>
              </div>

              {/* Content */}
              <div className="overflow-y-auto px-6 py-6 flex-grow" data-id="element-140">
                {activeModal === 'terms' ? termsContent : privacyContent}
              </div>

              {/* Footer */}
              <div className="px-6 py-4 border-t border-gray-100 flex-shrink-0" data-id="element-141">
                <button onClick={() => setActiveModal(null)} className="w-full bg-brand-brown text-white font-bold py-3 px-6 rounded-xl hover:bg-brand-brown/90 transition-colors" data-id="element-142">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}